import React, { useState, useEffect } from 'react';
import { Typography, Grid, CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

import PropertyCard from '../PropertyCard';
import PropertyMap from '../PropertyMap';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		overflow: 'visible'
	},
	firstTitle: {
		margin: '0.2rem 0',
		paddingBottom: 5,
		textAlign: 'center'
	},
	noActiveTitle: {
		color: theme.palette.grey['KN_light_grey'],
		textAlign: 'center',
		lineHeight: 2
	},
	centerItem: {
		marginTop: 40,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%'
	}
}));

export default function LeadNearbySoldTab({ listing, soldListings, isLoadingSoldListings }) {
	const classes = useStyles();

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
	const [isMobileGoogleMap, setIsMobileGoogleMap] = useState(window.innerWidth <= 960);
	const [selectedMapListing, setSelectedMapListing] = useState(null);
	const [showAllListings, setShowAllListings] = useState(false);

	useEffect(() => {
		function handleResize() {
			setIsMobile(window.innerWidth <= 600);
		}

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		function handleResize() {
			setIsMobileGoogleMap(window.innerWidth <= 960);
		}

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleSelectedMapListing = (selectedListingLocation) => {
		setSelectedMapListing(selectedListingLocation);
	};

	const handleShowMore = () => {
		setShowAllListings(true);
	};

	return isLoadingSoldListings ? (
		<div className={classes.centerItem}>
			<CircularProgress />
		</div>
	) : (
		<div className={classes.root}>
			{soldListings.length === 0 ? (
				''
			) : (
				<>
					<Typography variant="h4" component="h4" className={classes.firstTitle}>
						Nearby Sold Listings
					</Typography>
					<Grid container spacing={2}>
						{isMobileGoogleMap ? (
							<>
								<Grid item xs={12} md={6}></Grid>
								<Grid item xs={12} md={6}>
									<PropertyCard
										listingCardInfo={
											showAllListings
												? soldListings
												: soldListings.slice(0, 3)
										}
										isMobile={isMobile}
										selectedMapListing={selectedMapListing}
										isNearBySold={true}
									/>
									{!showAllListings && soldListings.length > 3 && (
										<div style={{ textAlign: 'center', marginTop: '1rem' }}>
											<Typography
												variant="body2"
												color="primary"
												onClick={handleShowMore}
												style={{
													cursor: 'pointer',
													textDecoration: 'underline'
												}}
											>
												View more Nearby Sold Listings
											</Typography>
										</div>
									)}
								</Grid>
							</>
						) : (
							<>
								<Grid item xs={12} md={12}></Grid>
								<Grid item xs={12} md={12}>
									<PropertyCard
										listingCardInfo={
											showAllListings
												? soldListings
												: soldListings.slice(0, 3)
										}
										isMobile={isMobile}
										selectedMapListing={selectedMapListing}
										isNearBySold={true}
									/>
									{!showAllListings && soldListings.length > 3 && (
										<div style={{ textAlign: 'center', marginTop: '1rem' }}>
											<Typography
												variant="body2"
												color="primary"
												onClick={handleShowMore}
												style={{
													cursor: 'pointer',
													textDecoration: 'underline'
												}}
											>
												View more Nearby Sold Listings
											</Typography>
										</div>
									)}
								</Grid>
							</>
						)}
					</Grid>
				</>
			)}
		</div>
	);
}
